import { lazy } from "react";
import { ticketsSVG, installationSVG, manteinanceSVG, unintallSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import( /* webpackChunkName: "tickets" */ './components/EntryPoint'));
const InstallationsEntryPoint = lazy(() => import(/* webpackChunkName: "installation_tickets" */ './components/InstallationsEntryPoint'));
const ManteinanceEntryPoint = lazy(() => import(/* webpackChunkName: "installation_tickets" */ './components/ManteinanceEntryPoint'))
const TicketsLoader = lazy(() => import(/* webpackChunkName: "ticketsLoader" */  './components/TicketsLoader'));
const FormTickets = lazy(() => import(/* webpackChunkName: "formTickets" */ './components/FormTickets'));

export const defaultPath = '/tickets';

export const innerSubRoutes = [
    {
        path: ``,
        Component: TicketsLoader,
        exact: true,
        icon: ticketsSVG,
        title: {
            key: 'tickets',
            plural: false
        },
        subTitle: {
            key: 'ticket_type_instalation',
            plural: false
        }
    },
    {
        path: `new`,
        Component: FormTickets,
        exact: true,
        icon: ticketsSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'ticket_type_instalation',
            plural: false
        }
    },
    {
        path: `:id`,
        Component: FormTickets,
        exact: true,
        icon: ticketsSVG,
        title: {
            key: 'tickets',
            plural: false
        },
        subTitle: {
            key: 'ticket_type_instalation',
            plural: false
        }
    }
];

export const installation_tickets = {
    path: `${defaultPath}/installations/`,
    keyTicketType: 'installations',
    Component: InstallationsEntryPoint,
    exact: false,
    icon: installationSVG,
    title: {
        key: 'installation',
        plural: false
    },
    subTitle: {
        key: 'ticket_type_instalation',
        plural: false
    },
    innerRoutes: innerSubRoutes.map(route => ({
        ...route,
        path: `${defaultPath}/installations/${route.path}`,
        icon: installationSVG
    }
    ))
}

export const manteinance_tickets = {
    path: `${defaultPath}/maintenance/`,
    keyTicketType: 'maintenance',
    Component: ManteinanceEntryPoint,
    exact: false,
    icon: manteinanceSVG,
    title: {
        key: 'maintenance',
        plural: false
    },
    subTitle: {
        key: 'ticket_type_maintenance',
        plural: false
    },
    innerRoutes: innerSubRoutes.map(route => ({
        ...route,
        path: `${defaultPath}/maintenance/${route.path}`,
        icon: manteinanceSVG
    }))
}

export const uninstall_tickets = {
    path: `${defaultPath}/uninstallations/`,
    keyTicketType: 'uninstallations',
    Component: ManteinanceEntryPoint,
    exact: false,
    icon: unintallSVG,
    title: {
        key: 'uninstallation',
        plural: false
    },
    subTitle: {
        key: 'ticket_type_uninstallation',
        plural: false
    },
    innerRoutes: innerSubRoutes.map(route => ({
        ...route,
        path: `${defaultPath}/uninstallations/${route.path}`,
        icon: installationSVG
    }
    ))
}
export const innerRoutes = [installation_tickets, manteinance_tickets, uninstall_tickets];

const Tickets = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: ticketsSVG,
    title: {
        key: 'tickets',
        plural: false
    },
    subTitle: {
        key: 'tickets_list',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path),
    availableSubMenu: true
};

export default Tickets;
